'use strict';

var cov_27vnfiqfb5 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.directive.js',
        hash = 'bf8b18a67863438771efe7f1b7a899fee00d6ee7',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 29
                },
                end: {
                    line: 13,
                    column: 55
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 29
                },
                end: {
                    line: 14,
                    column: 42
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 29
                },
                end: {
                    line: 15,
                    column: 34
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 31
                },
                end: {
                    line: 18,
                    column: 45
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 31,
                    column: 21
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 38
                },
                end: {
                    line: 24,
                    column: 70
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 24
                },
                end: {
                    line: 25,
                    column: 48
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 24
                },
                end: {
                    line: 30,
                    column: 27
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 28
                },
                end: {
                    line: 27,
                    column: 49
                }
            },
            '13': {
                start: {
                    line: 29,
                    column: 28
                },
                end: {
                    line: 29,
                    column: 49
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaDirective',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 36
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 18
                    },
                    end: {
                        line: 12,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 56
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 50
                    },
                    end: {
                        line: 17,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 62
                    },
                    end: {
                        line: 32,
                        column: 17
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 37
                    },
                    end: {
                        line: 26,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 53
                    },
                    end: {
                        line: 28,
                        column: 25
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 27
                    },
                    end: {
                        line: 28,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 43
                    },
                    end: {
                        line: 30,
                        column: 25
                    }
                },
                line: 28
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }, {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 22,
                        column: 70
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 20,
                        column: 28
                    }
                }, {
                    start: {
                        line: 21,
                        column: 24
                    },
                    end: {
                        line: 21,
                        column: 47
                    }
                }, {
                    start: {
                        line: 22,
                        column: 25
                    },
                    end: {
                        line: 22,
                        column: 45
                    }
                }, {
                    start: {
                        line: 22,
                        column: 49
                    },
                    end: {
                        line: 22,
                        column: 69
                    }
                }],
                line: 20
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

cov_27vnfiqfb5.s[0]++;
(function () {
    'use strict';

    cov_27vnfiqfb5.f[0]++;
    cov_27vnfiqfb5.s[1]++;
    angular.module('app').directive('mediaAutoUpload', MediaDirective);

    /* @ngInject */
    function MediaDirective($parse) {
        cov_27vnfiqfb5.f[1]++;
        cov_27vnfiqfb5.s[2]++;

        return {
            require: '?ngModel',
            link: function link(scope, element, attributes) {
                cov_27vnfiqfb5.f[2]++;

                var getter = (cov_27vnfiqfb5.s[3]++, $parse(attributes.ngModel));
                var setter = (cov_27vnfiqfb5.s[4]++, getter.assign);
                var $scope = (cov_27vnfiqfb5.s[5]++, scope);

                cov_27vnfiqfb5.s[6]++;
                $scope.$watch(attributes.ngModel, function () {
                    cov_27vnfiqfb5.f[3]++;

                    var file = (cov_27vnfiqfb5.s[7]++, getter($scope));
                    cov_27vnfiqfb5.s[8]++;
                    if ((cov_27vnfiqfb5.b[1][0]++, file) && (cov_27vnfiqfb5.b[1][1]++, (typeof file === 'undefined' ? 'undefined' : _typeof(file)) == 'object') && ((cov_27vnfiqfb5.b[1][2]++, file instanceof File) || (cov_27vnfiqfb5.b[1][3]++, file instanceof Blob))) {
                        cov_27vnfiqfb5.b[0][0]++;

                        var promise = (cov_27vnfiqfb5.s[9]++, $scope.$root.$Media.upload(file));
                        cov_27vnfiqfb5.s[10]++;
                        setter($scope, promise);
                        cov_27vnfiqfb5.s[11]++;
                        promise.then(function (data) {
                            cov_27vnfiqfb5.f[4]++;
                            cov_27vnfiqfb5.s[12]++;

                            setter($scope, data);
                        }, function (data) {
                            cov_27vnfiqfb5.f[5]++;
                            cov_27vnfiqfb5.s[13]++;

                            setter($scope, data);
                        });
                    } else {
                        cov_27vnfiqfb5.b[0][1]++;
                    }
                });
            }
        };
    }
})();